// extracted by mini-css-extract-plugin
export default {"banner":"OrderNotesBanner_banner__sRKJi","title":"OrderNotesBanner_title__4d69x","body":"OrderNotesBanner_body__rVq78"};